import { VNode } from "@stencil/core";

export interface TableDataRowType {
    selected?: boolean;
}

export interface SortedTableDataRowType {
    _uxTableInternalId: string;
    selected?: boolean;
}

export interface TableDataColumnType {
    label?: string;
    field?: string;
    sortable?: boolean;
    group?: boolean;
    getColumnMethods: () => Promise<{
        renderHeader: (tableState: object) => VNode[];
        renderCell: (row: SortedTableDataRowType, tableState: object) => VNode[];
        getSortString?: (row: SortedTableDataRowType) => string;
    }>;
}
